(function () {
  if (window.__pujhAccessoriesV2Loaded) return;
  window.__pujhAccessoriesV2Loaded = true;

  const init = () => {
    const root = document.querySelector('.pujh-acc');
    if (!root) return;

    document.documentElement.classList.add('pujh-acc-page');

    const hideCompareControls = () => {
      const candidates = document.querySelectorAll('button, a, div, span');

      candidates.forEach((element) => {
        const label = (element.textContent || '').replace(/\s+/g, ' ').trim();
        if (label !== 'Product comparison') return;

        const style = window.getComputedStyle(element);
        const rect = element.getBoundingClientRect();
        const appWrapper = element.closest(
          '[class*="snap-compare"], [id*="snap-compare"], [class*="snap_compare"], [id*="snap_compare"], [class*="product-comparison"], [id*="product-comparison"]'
        );

        if (
          appWrapper ||
          style.position === 'fixed' ||
          style.position === 'sticky' ||
          (rect.width < 120 && rect.height > 60)
        ) {
          const target = appWrapper || element;
          target.style.setProperty('display', 'none', 'important');
          target.setAttribute('aria-hidden', 'true');
        }
      });
    };

    hideCompareControls();

    const observer = new MutationObserver(hideCompareControls);
    observer.observe(document.body, { childList: true, subtree: true });

    window.setTimeout(hideCompareControls, 600);
    window.setTimeout(hideCompareControls, 1600);
    window.setTimeout(() => observer.disconnect(), 10000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
